// Cache service for storing and retrieving data
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes in milliseconds

class CacheService {
  constructor() {
    this.cache = new Map();
  }

  set(key, value) {
    this.cache.set(key, {
      value,
      timestamp: Date.now()
    });
  }

  get(key) {
    const item = this.cache.get(key);
    if (!item) return null;

    const isExpired = Date.now() - item.timestamp > CACHE_DURATION;
    if (isExpired) {
      this.cache.delete(key);
      return null;
    }

    return item.value;
  }

  clear() {
    this.cache.clear();
  }

  delete(key) {
    this.cache.delete(key);
  }

  isValid(key) {
    const item = this.cache.get(key);
    if (!item) return false;
    return Date.now() - item.timestamp <= CACHE_DURATION;
  }
}

export const cacheService = new CacheService();

// Cache keys
export const CACHE_KEYS = {
  FEATURED_BRANCHES: 'featured_branches',
  POPULAR_ADDONS: 'popular_addons',
  ALL_CATEGORIES: 'all_categories',
  ALL_SERVICES: 'all_services',
  CATEGORY_SERVICES: 'category_services',
};

export default cacheService; 